export function parseQueryString<T extends object>(str: string, shape: T): Partial<T> {
	const queryParams = str.slice(1).split('&');
	if (queryParams[0] === '') {
		return shape;
	}

	return queryParams
		.map(param => {
			const kvp = param.split('=');
			return { key: kvp[0], value: kvp[1] };
		})
		.reduce((query: any, kvp) => {
			if (kvp.key in shape) {
				query[kvp.key] = kvp.value;
			}
			return query;
		}, {});
}
